import collision from '@/assets/generated/world/forest/forest-collision.json';
import zones from '@/assets/generated/world/forest/forest-zones.json';
import { translatedRegionData, type SerializedMapData, type SerializedZoneData } from './region-map-data';

const data = translatedRegionData(
  collision as unknown as SerializedMapData,
  zones as unknown as SerializedZoneData,
  2560,
  0,
  2,
);
export const FOREST_COLLISION = data.collision;
export const FOREST_ZONES = data.zones;
